var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fechamento)?_c('recursos-pagina',{attrs:{"municipio-id":_vm.$route.params.municipioId}}):_c('legacy-list')
}
var staticRenderFns = []

export { render, staticRenderFns }